import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15f7f660"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 bg-light p-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "City Detail")
  ])
], -1))
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "table-responsive" }
const _hoisted_6 = { class: "table table-striped table-sm" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "#"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Name"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Country"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "City Topic"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Show"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Action")
  ])
], -1))
const _hoisted_8 = { class: "text-start" }
const _hoisted_9 = { class: "text-start" }
const _hoisted_10 = { class: "text-start" }
const _hoisted_11 = { class: "text-start" }
const _hoisted_12 = { class: "text-start" }
const _hoisted_13 = { class: "text-start" }
const _hoisted_14 = { class: "btn-group mr-2" }
const _hoisted_15 = { colspan: "11" }
const _hoisted_16 = { class: "overflow-hidden show" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 bg-light p-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "Rider Rate Card")
  ])
], -1))
const _hoisted_18 = {
  key: 1,
  class: "table table-sm"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "#"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Distance Type"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Per Unit Price"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Base Price"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Base Unit"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "is Base Rate"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "is Reference Rate"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "is Advance Rate"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "City"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Action")
  ])
], -1))
const _hoisted_20 = { class: "text-start" }
const _hoisted_21 = { class: "text-start" }
const _hoisted_22 = { class: "text-start" }
const _hoisted_23 = { class: "text-start" }
const _hoisted_24 = { class: "text-start" }
const _hoisted_25 = { class: "text-start" }
const _hoisted_26 = { class: "text-start" }
const _hoisted_27 = { class: "text-start" }
const _hoisted_28 = { class: "text-start" }
const _hoisted_29 = { class: "text-start" }
const _hoisted_30 = { class: "btn-group mr-2" }
const _hoisted_31 = { colspan: "11" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 bg-light p-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "City Based Peak Factor")
  ])
], -1))
const _hoisted_33 = { class: "overflow-hidden show" }
const _hoisted_34 = { class: "table table-sm" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "#"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Day "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Peakfactor"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Start time "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "End time"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Action")
  ])
], -1))
const _hoisted_36 = { class: "text-start" }
const _hoisted_37 = { class: "text-start" }
const _hoisted_38 = { class: "text-start" }
const _hoisted_39 = { class: "text-start" }
const _hoisted_40 = { class: "text-start" }
const _hoisted_41 = { class: "text-start" }
const _hoisted_42 = { class: "btn-group mr-2" }
const _hoisted_43 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("table", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_8, _toDisplayString($setup.city.id), 1),
                _createElementVNode("td", _hoisted_9, _toDisplayString($setup.city.name), 1),
                _createElementVNode("td", _hoisted_10, _toDisplayString($setup.city.country?.name), 1),
                _createElementVNode("td", _hoisted_11, _toDisplayString($setup.city.city_topic), 1),
                _createElementVNode("td", _hoisted_12, _toDisplayString($setup.city.is_show), 1),
                _createElementVNode("td", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_router_link, {
                      to: `/cities/${$setup.city.id}/edit`,
                      class: "btn btn-sm btn-secondary me-2"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Edit")
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    (!$setup.riderrate)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: `/riderrates/create/${$setup.city.id}`,
                          class: "btn btn-sm btn-secondary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Add Rider Rate")
                          ]),
                          _: 1
                        }, 8, ["to"]))
                      : _createCommentVNode("", true),
                    _hoisted_17,
                    ($setup.riderrate)
                      ? (_openBlock(), _createElementBlock("table", _hoisted_18, [
                          _hoisted_19,
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", _hoisted_20, _toDisplayString($setup.riderrate.id), 1),
                              _createElementVNode("td", _hoisted_21, _toDisplayString($setup.riderrate.distance_type), 1),
                              _createElementVNode("td", _hoisted_22, _toDisplayString($setup.riderrate.per_unit_price), 1),
                              _createElementVNode("td", _hoisted_23, _toDisplayString($setup.riderrate.base_price), 1),
                              _createElementVNode("td", _hoisted_24, _toDisplayString($setup.riderrate.base_unit), 1),
                              _createElementVNode("td", _hoisted_25, _toDisplayString($setup.riderrate.is_base_rate), 1),
                              _createElementVNode("td", _hoisted_26, _toDisplayString($setup.riderrate.is_reference_rate), 1),
                              _createElementVNode("td", _hoisted_27, _toDisplayString($setup.riderrate.is_advance_rate), 1),
                              _createElementVNode("td", _hoisted_28, _toDisplayString($setup.riderrate.city?.name), 1),
                              _createElementVNode("td", _hoisted_29, [
                                _createElementVNode("div", _hoisted_30, [
                                  _createVNode(_component_router_link, {
                                    to: `/riderrates/detail/${$setup.riderrate.id}`,
                                    class: "btn btn-sm btn-success me-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Detail")
                                    ]),
                                    _: 1
                                  }, 8, ["to"]),
                                  _createVNode(_component_router_link, {
                                    to: `/riderrates/edit/${$setup.riderrate.id}`,
                                    class: "btn btn-sm btn-secondary me-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Edit")
                                    ]),
                                    _: 1
                                  }, 8, ["to"]),
                                  _createElementVNode("a", {
                                    class: "btn btn-sm btn-danger me-2",
                                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.del($setup.riderrate.id)))
                                  }, " Delete")
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_31, [
                  _hoisted_32,
                  _createElementVNode("div", _hoisted_33, [
                    _createVNode(_component_router_link, {
                      to: `/peakfactor/create/${$setup.city.id}`,
                      class: "btn btn-sm btn-secondary"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Add Peak Factor")
                      ]),
                      _: 1
                    }, 8, ["to"]),
                    _createElementVNode("table", _hoisted_34, [
                      _hoisted_35,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.peakfactors, (peakfactor) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: peakfactor.id
                          }, [
                            _createElementVNode("td", _hoisted_36, _toDisplayString(peakfactor.id), 1),
                            _createElementVNode("td", _hoisted_37, _toDisplayString(peakfactor.day_name), 1),
                            _createElementVNode("td", _hoisted_38, _toDisplayString(peakfactor.peak_factor), 1),
                            _createElementVNode("td", _hoisted_39, _toDisplayString(peakfactor.time_start), 1),
                            _createElementVNode("td", _hoisted_40, _toDisplayString(peakfactor.time_end), 1),
                            _createElementVNode("td", _hoisted_41, [
                              _createElementVNode("div", _hoisted_42, [
                                _createVNode(_component_router_link, {
                                  to: `/peakfactor/${peakfactor.id}/edit`,
                                  class: "btn btn-sm btn-secondary me-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Edit")
                                  ]),
                                  _: 2
                                }, 1032, ["to"]),
                                _createElementVNode("a", {
                                  class: "btn btn-sm btn-danger me-2",
                                  onClick: ($event: any) => ($setup.delpeakfactor(peakfactor.id))
                                }, " Delete", 8, _hoisted_43)
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}